import http from "./http";

// 获取校区
export function getSchool() {
  return new Promise((resolve, reject) => {
    http.get("/school").then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

// 创建校区
export function postSchool(data = {}) {
  return new Promise((resolve, reject) => {
    http.post("/school", data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

// 校区添加校长/添加老师
export function post_user_school(data) {
  return new Promise((resolve, reject) => {
    http.post("school/role", data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

// 修改校区
export function putSchool(id, data = {}) {
  return new Promise((resolve, reject) => {
    http.put("/school?name=" + id, data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

// 获取所有用户
export function getAllUser() {
  return new Promise((resolve, reject) => {
    http.get("/account/name").then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

// 查看校区下校长/查看校区下老师
export function get_school_role(id, role_name) {
  return new Promise((resolve, reject) => {
    http.get(`/school/role?school_id=${id}&role_name=${role_name}`).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

// 删除校区下面的校长/老师
export function delete_principal(id) {
  return new Promise((resolve, reject) => {
    http.delete("school/role?id=" + id).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}
